var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardCardBottomLeftGradient(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 294,
    height: 215,
    viewBox: "0 0 294 215",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_694_619)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 131.086,
    cy: 239.395,
    r: 62.4846,
    fill: "url(#paint0_radial_694_619)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_694_619)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37.3142,
    cy: 214.236,
    r: 93.7712,
    fill: "url(#paint1_radial_694_619)",
    fillOpacity: 0.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_694_619",
    x: -31.3984,
    y: 76.9102,
    width: 324.969,
    height: 324.969,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_694_619"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_694_619",
    x: -176.457,
    y: 0.464844,
    width: 427.543,
    height: 427.543,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60,
    result: "effect1_foregroundBlur_694_619"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_694_619",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(131.086 239.395) rotate(90) scale(62.4846)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A73CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480208,
    stopColor: "#DEB5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_694_619",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.3142 214.236) rotate(90) scale(93.7712)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03FFB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480208,
    stopColor: "#4DFEC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardCardBottomLeftGradient);
export default __webpack_public_path__ + "static/media/dashboardCardBottomLeftGradient.b109974ea3e8bb013aeda20973755fd5.svg";
export { ForwardRef as ReactComponent };